export const parseQueryString = queryString => {
	if (!queryString) {
		return {};
	}

	// Replace leading '?'
	const cleanedStr = queryString.replace(/^\?/, '');

	// Split into individual key-value pairs
	const kvPairs = cleanedStr.split('&');

	return kvPairs.reduce((accumulator, kvPairString) => {
		const kvPair = kvPairString.split('=');
		if (!kvPair || kvPair.length < 1) {
			return accumulator;
		}
		const key = decodeURIComponent(kvPair[0]);
		const value = kvPair.length > 1 ? decodeURIComponent(kvPair[1]) : undefined;
		return {
			...accumulator,
			[key]: value
		};
	}, {});
};

export const buildQueryString = queryObject =>{
	if(queryObject === null){
		return "";
	}
	let constructedQueryString = "";
	Object.keys(queryObject).forEach(key =>{
		if(constructedQueryString.length === 0){
			constructedQueryString += "?";
		}
		else{
			constructedQueryString += "&";
		}
		constructedQueryString += key;

		if(queryObject[key] !== undefined){
				constructedQueryString += "=" + queryObject[key];
			}
	})
	return constructedQueryString;
}

export default parseQueryString(window.location.search);



// WEBPACK FOOTER //
// ./src/services/queryStringParameters.js